import { Modal } from "react-bootstrap"

const RemoveManager = ({
    showRemoveManagerWarningModal,
    setShowRemoveManagerWarningModal,
    selectedDataToRemoveManager,
    setSelectedDataToRemoveManager,
    handleRemoveTerritoryManager
}) => {
    return (
        <Modal
            show={showRemoveManagerWarningModal}
            onHide={() => setShowRemoveManagerWarningModal(false)}
            backdrop="static"
            keyboard={false}
            className="modal-md"
        >
            <Modal.Body>
                <h6 className='pb-3 fw-semibold'>Remove Territory Manager "{selectedDataToRemoveManager?.territory_manager?.name}" from {selectedDataToRemoveManager?.territory_name}</h6>
                <p>
                    Are you sure you want to remove this manager ?
                </p>
            </Modal.Body>
            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-outline-secondary flat-btn text-secondary"
                    onClick={() => { setSelectedDataToRemoveManager(''); setShowRemoveManagerWarningModal(false) }}
                    data-bs-dismiss="modal">
                    Cancel
                </button>
                <button
                    type="button"
                    className="btn btn-danger btn-blue"
                    data-bs-dismiss="modal"
                    onClick={() => {
                        handleRemoveTerritoryManager(selectedDataToRemoveManager);
                        setShowRemoveManagerWarningModal(false)
                    }}
                >
                    Yes, Remove
                </button>
            </Modal.Footer>
        </Modal>
    )
}
export default RemoveManager